import '../../../../jsscripts/jquery/knockout/knockout.mapping';
import page from '../../../smartpak/page';
import authentication from '../../customeraccount/authentication';


function CartSubmitViewmodel (cartItemsViewModelInstance, toggleValidationMessage){
    this.cartItemsViewModel = cartItemsViewModelInstance;
    this.toggleValidationMessage = toggleValidationMessage;
}

CartSubmitViewmodel.prototype.handleSubmit = function (data, event) {
    event.preventDefault();
    const link = event.currentTarget.href; 

    data.cartItemsViewModel.validateAutoShipSupplyItems();

    if (data.cartItemsViewModel.supplyItemsAreAutoShipValid()) {
        data.toggleValidationMessage(false);

        authentication.checkAuthenticatedThenLaunchLoginOrExecuteTask(function() {
            if (window.fireBeginCheckoutEvent) {
                window.fireBeginCheckoutEvent('standard');
            }
            page.redirectToUrl(link);
        }, {
            redirectURL: link,
            create: this.cartItemsViewModel.containsAutoShipItems(),
            isCart: true
        });
        return;
    }

    if (window.fireBeginCheckoutEvent) {
        window.fireBeginCheckoutEvent('standard');
    }

    data.toggleValidationMessage(true);
};


export default CartSubmitViewmodel;
